import { BaseStripeElementsOptions } from "@stripe/stripe-js";
import { useMemo } from "react";

export function useStripeOptions(): BaseStripeElementsOptions {
    return useMemo(
        () => ({
            appearance: {
                variables: {
                    spacingUnit: "4px",
                    spacingGridRow: "24px",
                    spacingGridColumn: "32px",
                    fontFamily: `"Inter", sans-serif`,
                    colorText: "#515D71", // gray-700,
                    colorTextSecondary: "#515D71", // gray-700,
                    colorDangerText: "#ec535a", // red-500,
                },
                rules: {
                    ".Input": {
                        color: "#0F1826", // gray-900,
                    },
                },
            },
            loader: "always",
        }),
        [],
    );
}
